export default __webpack_public_path__ + "static/media/close.66214d97.svg";